import { Col, Row } from 'react-bootstrap';
import bg50 from 'assets/img/bg/bg-50.png'; 

const HeroHeader = () => {
  return (
    <section className="pb-8" id="home">
      <div className="container-small hero-header-container px-lg-6 px-xxl-3">
        <Row className="align-items-center">
          <Col xs={12} lg={6} className="text-lg-start text-center pt-4 pb-4 order-1 order-lg-0">
            <div>
               <h1 className="fs-3 fs-lg-2 fs-md-1 fs-xl-1 fw-black mb-1">
    <span className="text-primary">Parkes Abogados</span>
  </h1>
              <h3 className="mb-3 text-secondary">
               Desde 1973
              </h3> 
              <p className="fs-7 mb-3 text-body-tertiary fw-semibold">
              Abogados Especializados en Derecho del Trabajo
              </p>
              <a
                href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg btn-success rounded-pill px-5 shadow"
                style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
              >
                WhatsApp <i className="bi bi-whatsapp ms-2"></i>
              </a>
            </div>
          </Col>
          <Col xs={12} lg={6} className="text-center order-0 order-lg-1 mb-5 mb-lg-0">
            <img
              className="img-fluid rounded-3 shadow-lg"
              src={bg50}
              alt="Estudio Parkes Abogados"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default HeroHeader;